// @flow
import withDateFromTo from './hocs/withDateFromTo';
import DateFromToFilterView from './views/DateFromToFilterView';


export default withDateFromTo(DateFromToFilterView);
